import { Api } from 'tools/api';
import State from 'tools/state';
import { apiFetch, ApiRequest, useRemoteList, useRemoteListLegacy } from 'framework/api';
import { HealthReason } from 'framework/entities/healthReason';
import { getReasons } from 'areas/health/api';

export class ApplicationsApi {
	static listUrl(accountId: string, includeSubaccounts?: boolean) {
		return (
			Api.accountRoot(accountId) +
			'summary/applications?includeSubaccounts=' +
			(includeSubaccounts !== undefined ? includeSubaccounts : State.includeSubaccounts)
		);
	}

	static list(accountId?: string, includeSubaccounts?: boolean) {
		return Api.fetch(ApplicationsApi.listUrl(accountId, includeSubaccounts));
	}

	static details(applicationId: string, canUpdate?: boolean) {
		return Api.fetch(Api.serverRoot() + 'applications/' + applicationId + '?update=' + canUpdate);
	}

	static detailsReadonly(applicationId: string, sessionId?: string) {
		return Api.fetch(Api.sessionRoot(sessionId) + 'applications/' + applicationId + '?update=false');
	}

	static save(application: object) {
		return Api.fetchPost(Api.serverRoot() + 'applications', application);
	}

	static delete(applicationIds: string[]) {
		return Api.fetchPost(Api.serverRoot() + 'applications/delete', applicationIds);
	}

	static async getLastReasons(applicationId: string, accountId?: string): Promise<HealthReason[]> {
		const result = await apiFetch(getReasons({ accountId, applicationIds: [applicationId], mode: 'LAST' }));
		return result.success ? result.data.items.map((x) => x.data) : [];
	}
	static getDependencies(applicationId: string) {
		return Api.fetch(Api.serverRoot() + 'applications/' + applicationId + '/dependencies');
	}
	static deleteDependencies(applicationId: string) {
		return Api.fetchDelete(Api.serverRoot() + 'applications/' + applicationId + '/dependencies/deleteAll');
	}

	static getAssetGroups(assetGroupId: string, includeSubaccounts?: boolean) {
		return Api.fetchPost(
			Api.accountRoot() + 'health/assetGroups/treelist?includeSubaccounts=' + includeSubaccounts,
			{},
		);
	}

	static getSearchUrl() {
		return Api.accountRoot() + 'applications/search/lite?includeSubaccounts=false';
	}
}

type GetApplicationsArgs = {
	accountId?: string;
};

export function getApplications(args?: GetApplicationsArgs) {
	return new ApiRequest<any[]>({
		url: 'summary/applications',
		subaccountsFilter: true,
		accountBased: true,
		accountId: args?.accountId,
	});
}
